mutation CreateStagesetStarter($input: StagesetStarterCreateInput!) {
    stagesetStarterCreate(input: $input) {
        stageset {
            name
            id
            htmlUrlPath
        }
    }
}
